export function getApiUrl () {
  const VUE_APP_BASE_API = process.env.VUE_APP_BASE_API
  // const NODE_ENV = process.env.NODE_ENV
  const url = '/source/'
  // const urlRoot = VUE_APP_BASE_API + (NODE_ENV !== 'production' ? '/2025/615' : '') + url
  const urlRoot = VUE_APP_BASE_API + '/2025/615' + url
  return urlRoot
}
